export default __webpack_public_path__ + "static/media/groupIcon.840cb3cf.svg";